import { render } from "./MsisdnPriceEditor.vue?vue&type=template&id=611bd27f"
import script from "./MsisdnPriceEditor.vue?vue&type=script&lang=js"
export * from "./MsisdnPriceEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__